
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.808"}},[_c('path',{attrs:{"d":"M53.496 31.411H11.904l9.946-16.275 9.946 16.275M29.083 15.136l9.946 16.275M36.317 15.136l9.946 16.275M31.796 36.836v-5.425M11.904 31.411v5.425M21.85 15.136h22.604M25.165 20.561h22.906M28.481 25.986h23.207M30.892 51.303h21.7c.499 0 .904-.405.904-.904v-7.234c0-.499-.405-.904-.904-.904H39.029M39.029 31.411v10.85M46.263 31.411v10.85"}}),_c('path',{attrs:{"d":"M11.904 47.686h19.892v3.617H11.904zM15.521 44.069h19.892v3.617H15.521zM11.904 40.453h19.892v3.616H11.904z"}})])])
          )
        }
      }
    